<template>
    <div>
        <Transition name="fade">
            <div @click="closeModal" v-if="isOpen" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.2); z-index: 10;"></div>
        </Transition>
        <div :style="{ height: height, width: width }" class="basic_frame" :class="{ open: isOpen }">
            <slot></slot>
        </div>
    </div>
</template>

<script>

export default {
    name: 'ModalFrameBasic',
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        closeModal: {
            type: Function,
            default: () => { }
        },
        height: {
            type: String,
            default: '',
        },
        width: {
            type: String,
            default: 'calc(100% - 40px)'
        }
    },
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family);
    color: #101014;
}

.basic_frame {
    background-color: #fff;
    padding: 20px;
    border-radius: 20px;
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translate(-50%, 0);
    transition: 0.5s all;
    z-index: 20;
    /* text-align: center; */
    font-weight: 500;
}

.basic_frame.open {
    top: 50%;
    transform: translate(-50%, -50%);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
}
</style>